export default __webpack_public_path__ + "static/media/leroy_merlin-logo.5064aa96.png";